/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { ApiError } from './ApiError'
import { ApiErrorFromJSON, ApiErrorFromJSONTyped, ApiErrorToJSON } from './ApiError'

/**
 *
 * @export
 * @interface EnvelopedCatalogLocationSeoFieldsUpdateAdmin
 */
export interface EnvelopedCatalogLocationSeoFieldsUpdateAdmin {
  /**
   *
   * @type {any}
   * @memberof EnvelopedCatalogLocationSeoFieldsUpdateAdmin
   */
  body: any | null
  /**
   *
   * @type {Array<ApiError>}
   * @memberof EnvelopedCatalogLocationSeoFieldsUpdateAdmin
   */
  errors: Array<ApiError>
}

/**
 * Check if a given object implements the EnvelopedCatalogLocationSeoFieldsUpdateAdmin interface.
 */
export function instanceOfEnvelopedCatalogLocationSeoFieldsUpdateAdmin(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'body' in value
  isInstance = isInstance && 'errors' in value

  return isInstance
}

export function EnvelopedCatalogLocationSeoFieldsUpdateAdminFromJSON(
  json: any,
): EnvelopedCatalogLocationSeoFieldsUpdateAdmin {
  return EnvelopedCatalogLocationSeoFieldsUpdateAdminFromJSONTyped(json, false)
}

export function EnvelopedCatalogLocationSeoFieldsUpdateAdminFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EnvelopedCatalogLocationSeoFieldsUpdateAdmin {
  if (json === undefined || json === null) {
    return json
  }
  return {
    body: json['body'],
    errors: (json['errors'] as Array<any>).map(ApiErrorFromJSON),
  }
}

export function EnvelopedCatalogLocationSeoFieldsUpdateAdminToJSON(
  value?: EnvelopedCatalogLocationSeoFieldsUpdateAdmin | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    body: value.body,
    errors: (value.errors as Array<any>).map(ApiErrorToJSON),
  }
}
